import {useEffect} from "react";
import {useMap, useMapLayerProvider} from "base/component/geo";
import {useList} from "base/provider";

const mapStyle = {
    width: "100%",
    height: "650px",
};

const EntityListMap = ({
    layer: layerHook,
    service,
    selectedElement = null,
    onSelectElement = null,
}) => {
    const [{setItems, items, setSelectedIds}] = useMapLayerProvider(service);
    const {filter, setSize} = useList();

    const {mapRef, createMap} = useMap();

    const layer = layerHook(onSelectElement);

    useEffect(() => {
        const map = createMap();
        layer.createLayer(map);

        return () => {
            if (map._loaded) {
                map.remove();
            }
        };
    }, []);

    useEffect(() => {
        service.getFeatures(filter).then(result => {
            setItems(result);
            setSize(result.features.length);
        });
    }, [filter]);

    useEffect(() => {
        layer.clearLayer();
        layer.updateLayer(items);
    }, [items]);

    useEffect(() => {
        console.log("selectedElement", {selectedElement}, setSelectedIds);
        // TODO Changes not reflected in map because useProvider() (from useMapLayerProvider) is not listening
        if (setSelectedIds) {
            setSelectedIds([selectedElement]);
        }
    }, [selectedElement]);

    return <div id="map" style={mapStyle} ref={mapRef} />;
};

export default EntityListMap;
